module.exports = __webpack_public_path__ + "static/hollywood-room-3-bc9af32396a4d53c25f9cab6913498a5.jpg";